import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import reducers from './reducers'
import middleware from './middleware'
import {createStore} from 'redux';
import {Provider} from 'react-redux';

const polyfills = []

if (!window.fetch || !window.Promise) {
  console.log('No Promise, polyfilling for IE');
  polyfills.push(import(/* webpackChunkName: "polyfillreactie" */ 'react-app-polyfill/ie11'))
  polyfills.push(import(/* webpackChunkName: "polyfillreactstable" */ 'react-app-polyfill/stable'))
  polyfills.push(import('core-js/stable/number'))
  polyfills.push(import('core-js/stable/number/is-nan'))
  if (!Number.isNaN) { //strange that we need to code isnan again
    Object.defineProperty(Number, 'isNaN', {
      value: function(value) {     
        // eslint-disable-next-line no-self-compare
        return typeof input === 'number' && value !== value; 
      }
    });
  }
  if (!String.prototype.replaceAll) {
    // eslint-disable-next-line no-extend-native
    String.prototype.replaceAll = function(str, newStr){
      // If a regex pattern
      if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
        return this.replace(str, newStr);
      }
  
      // If a string
      return this.replace(new RegExp(str, 'g'), newStr);
  
    };
  }
}

const store = createStore(reducers,middleware);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}> 
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
